module.exports = __webpack_public_path__ + "img/audio.33ce8b35.png";